<template>
	<!-- Main Sections -->
	<main class="main-wrapper bg-lightest-gray">

		<!-- Title Banner Start -->
		<section class="title-banner">
			<div class="container-fluid">
				<div class="banner-wrapper">
					<img src="/assets/media/banner/left-image.png" alt="" class="banner-image1">
					<h1 class="dark-black fw-600">Избранное</h1>
					<img src="/assets/media/banner/right-image.png" alt="" class="banner-image2">
				</div>
			</div>
		</section>
		<!-- Title Banner End -->

		<!-- Wishlist Area Start -->
		<section class="cart py-40">
			<div class="container-fluid">
				<div class="d-lg-block d-none">
					<table class="cart-table wishlist mb-16">
						<thead>
							<tr>
								<th>Товары</th>
								<th>Цена</th>
								<th>Доступность</th>
								<th>Количество</th>
								<th>Сумма</th>
								<th></th>
							</tr>
						</thead>
					</table>
					<table class="cart-table" v-for="product in appModel.wishlistProducts" :key="product.id">
						<tbody>
							<tr class="table-row wishlist-row">
								<td class="pd">
									<div class="product-detail-box">
										<div class="cus-checkBox">
											<input type="checkbox" :id="'box'+product.id" :value="product.id" v-model="selectedProducts">
											<label :for="'box'+product.id" class="light-gray"></label>
										</div>
										<a href="#" class="h5 dark-black" @click.prevent="appModel.deleteProductFromWishlist(product.id)">
											<i class="fal fa-times"></i>
										</a>
										<div class="img-block">
											<router-link :to="{path: '/catalog/'+product.id}">
												<img :src="product.poster" style="height: 65px;" alt="">
											</router-link>
										</div>
										<div class="d-block text-start">
											<h6>
												<router-link :to="{path: '/catalog/'+product.id}">{{product.name}}</router-link>
											</h6>
										</div>
	
									</div>
								</td>
								<td>
									<div class="fw-500">
										<div class="light-gray text-decoration-line-through" v-if="product.oldPrice">{{number_format(product.oldPrice)}} тг</div>
										<div>{{number_format(product.price)}} тг</div>
									</div>
								</td>
								<td>
									<p class="fw-500 stock-label m-auto">Есть в наличии</p>
								</td>
								<td>
									<div class="quantity-controller quantity-wrap" v-if="appModel.hasProductInBasket(product.id)">
										<input class="decrement" type="button" value="-" @click="appModel.getProductFromBasket(product.id).count--">
										<input type="number" @wheel="$event.target.blur()" v-model.number="appModel.getProductFromBasket(product.id).count" class="number noscroll">
										<input class="increment" type="button" value="+" @click="appModel.getProductFromBasket(product.id).count++">
									</div>
									<div class="quantity-controller quantity-wrap" v-else>
										<input class="decrement" type="button" value="-" @click="product.count--">
										<input type="number" @wheel="$event.target.blur()" v-model.number="product.count" class="number noscroll">
										<input class="increment" type="button" value="+" @click="product.count++">
									</div>
								</td>
								<td>
									<div class="fw-500">
										<div>{{number_format(product.price * product.count)}} тг</div>
									</div>
								</td>
								<td>
									<a href="#" @click.prevent="toggleProductBasket(product)" :class="{'cus-btn-3': !appModel.hasProductInBasket(product.id), 'cus-btn-2': appModel.hasProductInBasket(product.id)}">
										<span v-if="!appModel.hasProductInBasket(product.id)">В КОРЗИНУ</span>
										<span v-else>ИЗ КОРЗИНЫ</span>
									</a>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="table-bottom-row varient-2 bg-white">
					<div class="d-flex justify-content-between flex-wrap gap-16 pt-3">
						<div class="d-flex align-items-center gap-16">
							<h5 class="color-primary">Итого на: {{number_format(productsPriceSum)}} тг</h5>
							<h5 class="color-primary" v-if="selectedProducts.length > 0">Выбранное на: {{number_format(selectedProductsPriceSum)}} тг</h5>
						</div>
						<div class="d-flex align-items-center gap-16 flex-wrap">
							<a href="#" class="cus-btn-2" @click.prevent="addSelectedToBasket">Добавить выбранное в корзину</a>
							<a href="#" class="cus-btn-3" @click.prevent="addAllToBasket">Добавить все в корзину</a>
						</div>
					</div>
				</div>
			</div>
		</section>
		<!-- Wishlist Area End -->
		
		<benefits :footer-class="['bg-white']" />
	</main>
	<!-- Main Sections -->
</template>

<style lang="scss">
      
</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

import Benefits from '@/components/Benefits';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'InterMagTech'});
	},
	data: () => ({
		selectedProducts: [],
	}),
	watch: {
		'appModel.wishlistProducts': {
			handler(newVal) {
				newVal.forEach((product) => {
					if (product.count <= 0 || isNaN(product.count)) {
						product.count = 1;
					}
				});
				localStorage.setItem('wishlistProducts', JSON.stringify(this.appModel.wishlistProducts));
			},
			deep: true,
		},
		'appModel.basketProducts': {
			handler(newVal) {
				newVal.forEach((product) => {
					if (product.count <= 0 || isNaN(product.count)) {
						product.count = 1;
					}
				});
				localStorage.setItem('basketProducts', JSON.stringify(this.appModel.basketProducts));
			},
			deep: true,
		},
	},
	computed: {
		productsPriceSum(){
			return this.appModel.wishlistProducts.reduce((sum, product) => sum + (product.price * product.count), 0);
		},
		selectedProductsPriceSum(){
			return this.selectedProducts.reduce((sum, productId) => {
				const product = this.appModel.wishlistProducts.find(p => p.id === productId);
				return sum + (product ? product.price * product.count : 0);
			}, 0);
		},
	},
	methods: {
		number_format(value){
			return lib.number_format(value, 0, '.', ' ');
		},
		
		toggleProductBasket(product){
			if (this.appModel.hasProductInBasket(product.id)) {
				product.count = this.appModel.getProductFromBasket(product.id).count||1;
			}
			this.appModel.toggleProductBasket(product, product.count);
		},
		
		addSelectedToBasket(){
			if (this.selectedProducts.length <= 0) return false;
			this.selectedProducts.forEach((productId) => {
				const product = this.appModel.wishlistProducts.find(p => p.id == productId);
				if (!this.appModel.hasProductInBasket(product.id)) {
					this.appModel.addProductToBasket(product, product.count);
				}
			});
		},
		addAllToBasket(){
			if (this.appModel.wishlistProducts.length <= 0) return false;
			this.appModel.wishlistProducts.forEach((product) => {
				if (!this.appModel.hasProductInBasket(product.id)) {
					this.appModel.addProductToBasket(product, product.count);
				}
			});
		},
	},
	mounted(){
		window.scrollTo(0, 0);
	},
	beforeRouteUpdate(to, from, next){
		window.scrollTo(0, 0);
		next();
	},
	components: {
		Benefits
	},
};
</script>